// @generated by protobuf-ts 2.9.5 with parameter optimize_code_size,long_type_number
// @generated from protobuf file "bianka/enums/activity/element_type.proto" (package "bianka.enums.activity", syntax proto3)
// tslint:disable
/**
 * @generated from protobuf enum bianka.enums.activity.ElementType
 */
export enum ElementType {
    /**
     * @generated from protobuf enum value: ELEMENT_TYPE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: ELEMENT_TYPE_LINK = 1;
     */
    LINK = 1,
    /**
     * @generated from protobuf enum value: ELEMENT_TYPE_BUTTON = 2;
     */
    BUTTON = 2,
    /**
     * @generated from protobuf enum value: ELEMENT_TYPE_IMAGE = 3;
     */
    IMAGE = 3,
    /**
     * @generated from protobuf enum value: ELEMENT_TYPE_CARD = 4;
     */
    CARD = 4,
    /**
     * @generated from protobuf enum value: ELEMENT_TYPE_TAB = 5;
     */
    TAB = 5,
    /**
     * @generated from protobuf enum value: ELEMENT_TYPE_POPUP = 6;
     */
    POPUP = 6
}
